// extracted by mini-css-extract-plugin
export default {"slider-wrapper":"ReviewSlider_slider-wrapper__QXIMa","review-item":"ReviewSlider_review-item__s79TZ","fade-in":"ReviewSlider_fade-in__zGcKy","fadeIn":"ReviewSlider_fadeIn__Yx33D"};